import { render, staticRenderFns } from "./AddOrderComponent.vue?vue&type=template&id=414b8c27&"
import script from "./AddOrderComponent.vue?vue&type=script&lang=js&"
export * from "./AddOrderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports